import api from './apiClient';

export const raceResultsAPI = {
  // CMS endpoints (admin)
  importResults: async (raceId, jsonString) => {
    const response = await api.post(
      `/api/cms/races/${raceId}/results/import`,
      jsonString,
      { headers: { 'Content-Type': 'application/json' }, transformRequest: [(data) => data] }
    );
    return response.data;
  },
  getResults: async (raceId, params = {}) => {
    const response = await api.get(`/api/cms/races/${raceId}/results`, { params });
    return response.data;
  },
  getTeamResults: async (raceId, params = {}) => {
    const response = await api.get(`/api/cms/races/${raceId}/results/teams`, { params });
    return response.data;
  },
  getResultsSummary: async (raceId) => {
    const response = await api.get(`/api/cms/races/${raceId}/results/summary`);
    return response.data;
  },
  deleteAllResults: async (raceId) => {
    const response = await api.post(`/api/cms/races/${raceId}/results`, {});
    return response.data;
  },
  deleteResult: async (raceId, id) => {
    const response = await api.post(`/api/cms/races/${raceId}/results/${id}`, {});
    return response.data;
  },
  // Public endpoints
  getPublicResults: async (raceId, params = {}) => {
    const response = await api.get(`/api/races/${raceId}/results`, { params });
    return response.data;
  },
  getPublicTeamResults: async (raceId, params = {}) => {
    const response = await api.get(`/api/races/${raceId}/results/teams`, { params });
    return response.data;
  },
  getPublicResultsSummary: async (raceId) => {
    const response = await api.get(`/api/races/${raceId}/results/summary`);
    return response.data;
  },
};
